<script lang="ts">
  import { recommendation } from "../../stores/recommendation"
  import Title from "../Common/Title.svelte"
  import Text from "../Common/Text.svelte"
  import Card from "../Common/Card.svelte"
  import ExpertHeading from "../Expert/ExpertHeading.svelte"

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  $: details = $recommendation.details
</script>

{#if details}
  <Card class="recommendation-card">
    <Title class="recommendation-title">
      {details.title}
    </Title>
    <Text class="recommendation-description">
      {@html details.description}
    </Text>
    <ExpertHeading />
  </Card>
{/if}
